"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgArrowLeft(props, svgRef) {
  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), {}, {
    children: [(0, _jsxRuntime.jsx)("defs", {
      children: (0, _jsxRuntime.jsx)("path", {
        id: "arrowLeft_svg__a",
        d: "M13.472 9.306H8.199l2.293-2.283a.698.698 0 00-.987-.986l-3.474 3.47a.716.716 0 000 .986l3.474 3.468a.692.692 0 00.987 0 .693.693 0 000-.985l-2.293-2.283h5.273a.694.694 0 100-1.387z"
      })
    }), (0, _jsxRuntime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [(0, _jsxRuntime.jsx)("mask", {
        id: "arrowLeft_svg__b",
        fill: "currentColor",
        children: (0, _jsxRuntime.jsx)("use", {
          xlinkHref: "#arrowLeft_svg__a"
        })
      }), (0, _jsxRuntime.jsx)("use", {
        fill: "currentColor",
        fillRule: "nonzero",
        xlinkHref: "#arrowLeft_svg__a"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "currentColor",
        d: "M0 0h20v20H0z",
        mask: "url(#arrowLeft_svg__b)"
      })]
    })]
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=ArrowLeft.js.map